import { LocalDate } from '@js-joda/core';
import { EnergyType, Property, SourceService, SundialEnergyConnectionTypes, SundialSite } from '../types';

const DEMO_HISTORY_MONTHS = 18;

const mostRecentReadingTimestamp = (): string => `${LocalDate.now().toString()}T13:15:00.000Z`;

const earliestReadingTimestamp = (): string =>
  `${LocalDate.now().minusMonths(DEMO_HISTORY_MONTHS).toString()}T12:30:00.000Z`;

const demoSundialSite = (): SundialSite => {
  const earliest = earliestReadingTimestamp();

  return {
    timeZone: 'America/New_York',
    dataSources: [
      { sourceType: EnergyType.production, sourceService: SourceService.solaredge, sourceId: 'demo-production' },
      { sourceType: EnergyType.consumption, sourceService: SourceService.solaredge, sourceId: 'demo-consumption' },
      { sourceType: EnergyType.gridConsumption, sourceService: SourceService.solaredge, sourceId: 'demo-grid' },
    ],
    connections: [
      SundialEnergyConnectionTypes.pvToHome,
      SundialEnergyConnectionTypes.gridToHome,
      SundialEnergyConnectionTypes.pvToGrid,
    ],
    earliestReadingTimestamp: earliest,
    mostRecentReadingTimestamp: mostRecentReadingTimestamp(),
    firstMeasurableGenerationTimestamp: earliest,
  };
};

export const withDemoSundialSite = (property: Property): Property => ({
  ...property,
  sundialSite: demoSundialSite(),
});
